import { useTranslation } from 'react-i18next'

import { Box, Stack } from '@mui/material'

import { TLGTypography } from '@components/TLGTypography'

import {
  containerSx,
  contentSx,
  numberSx,
  rowSx,
  textSx,
  titleSx,
} from './styles'

const Section1 = () => {
  const { t } = useTranslation()

  return (
    <Box data-testid="about-section-1" sx={containerSx}>
      <Stack sx={contentSx}>
        <TLGTypography responsiveVariant={{ xs: 'h5', md: 'h4' }} sx={titleSx}>
          {t('We exist to solve two problems')}:
        </TLGTypography>

        <Stack direction="row" sx={rowSx}>
          <TLGTypography
            responsiveVariant={{ xs: 'h6', md: 'h5' }}
            sx={numberSx}
          >
            1
          </TLGTypography>
          <TLGTypography
            responsiveVariant={{ xs: 'subtitle1', md: 'h5' }}
            sx={textSx}
          >
            {t(
              'Empowering Tech Customers to find their perfect-match tech solutions and partners with ease and efficiency.'
            )}
          </TLGTypography>
        </Stack>

        <Stack direction="row" sx={rowSx}>
          <TLGTypography
            responsiveVariant={{ xs: 'h6', md: 'h5' }}
            sx={numberSx}
          >
            2
          </TLGTypography>
          <TLGTypography
            responsiveVariant={{ xs: 'subtitle1', md: 'h5' }}
            sx={textSx}
          >
            {t(
              'Connecting technology providers with qualified leads actively seeking their products and services.'
            )}
          </TLGTypography>
        </Stack>
      </Stack>
    </Box>
  )
}

export { Section1 }
